<app-modal-shell [config]="modalConfig">
<div modal-content>
  <p class="dialog-subtitle">
    Unidad: <strong>{{ data.unitName }}</strong>
    <span *ngIf="data.currentParentName" class="current-parent">
      &nbsp;·&nbsp;Superior actual: {{ data.currentParentName }}
    </span>
  </p>

  <form [formGroup]="form" class="change-parent-form">

    <!-- Tipo de cambio -->
    <div class="field-group">
      <label class="field-label">Tipo de cambio</label>
      <mat-radio-group formControlName="isCorrection" class="radio-group">
        <mat-radio-button [value]="true">
          <span class="radio-label">Corrección de dato</span>
          <span class="radio-hint">El dato estaba mal cargado. No genera registro histórico.</span>
        </mat-radio-button>
        <mat-radio-button [value]="false">
          <span class="radio-label">Cambio estructural</span>
          <span class="radio-hint">La unidad se muda a otra estructura. Queda registrado con fecha efectiva.</span>
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <!-- Aviso corrección -->
    <div class="warning-banner" *ngIf="isCorrection">
      <mat-icon>info</mat-icon>
      <p>
        Esta acción actualiza la unidad superior sin dejar registro histórico.
        El sistema quedará como si <strong>{{ data.unitName }}</strong> siempre hubiera pertenecido a la nueva unidad superior.
      </p>
    </div>

    <!-- Nueva unidad superior (autocomplete) -->
    <mat-form-field class="full-width">
      <mat-label>Nueva unidad superior</mat-label>
      <mat-icon matPrefix>account_tree</mat-icon>
      <input
        matInput
        formControlName="parentUnitSearch"
        [matAutocomplete]="parentAuto"
        placeholder="Buscar por nombre…"
        #parentAutoTrigger="matAutocompleteTrigger"
        autocomplete="off" />
      <mat-spinner matSuffix diameter="18" *ngIf="isSearchingParent"></mat-spinner>
      <mat-error *ngIf="form.get('parentUnitId')?.hasError('required') && form.get('parentUnitId')?.touched">
        Seleccioná una unidad de la lista.
      </mat-error>
      <mat-autocomplete #parentAuto="matAutocomplete" (optionSelected)="onParentSelected($event.option.value)">
        <mat-optgroup *ngFor="let group of filteredParentGroups" [label]="group.levelLabel">
          <mat-option *ngFor="let unit of group.units" [value]="unit">
            <span class="option-name">{{ unit.name }}</span>
          </mat-option>
        </mat-optgroup>
        <mat-option *ngIf="!isSearchingParent && filteredParentGroups.length === 0 && form.get('parentUnitSearch')?.value?.length > 1" disabled>
          Sin resultados
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Fecha efectiva (solo cambio estructural) -->
    <app-date-picker
      *ngIf="!isCorrection"
      class="full-width"
      label="Fecha efectiva del cambio"
      formControlName="effectiveDate"
      [errorMessages]="{
        required: 'La fecha efectiva es requerida para cambios estructurales.',
        matDatepickerParse: 'Ingresa una fecha valida con formato dd/mm/aaaa.'
      }">
    </app-date-picker>

    <!-- Motivo -->
    <mat-form-field class="full-width">
      <mat-label>Motivo <span class="optional-hint">(opcional)</span></mat-label>
      <textarea matInput formControlName="reason" rows="2" maxlength="500" placeholder="Describí el motivo del cambio…"></textarea>
      <mat-hint align="end">{{ form.get('reason')?.value?.length || 0 }}/500</mat-hint>
    </mat-form-field>

  </form>
</div>

<ng-container modal-actions>
  <button mat-button type="button" (click)="onCancel()">Cancelar</button>
  <button mat-flat-button color="primary" type="button" (click)="onConfirm()" [disabled]="isSaving">
    <mat-spinner diameter="18" *ngIf="isSaving"></mat-spinner>
    <span *ngIf="!isSaving">Confirmar</span>
  </button>
</ng-container>
</app-modal-shell>
